module.exports = __webpack_public_path__ + "static/media/close_door.45e26679.png";